import React from 'react';
import { Control } from 'react-hook-form';
import { ControllerWrapper } from '../../../../../../hooks/providers/ControllerWrapper';
import { InviteFlowFields } from '../../../../consts';
import { LiliTextInput } from '../../../../../../DesignSystem/LiliTextInput/LiliTextInput';

import { InviteFormType } from '../../InviteFormStep';

import { removeWhiteSpacesFromString } from '../../../../../../services/general.service';

interface FirstNameInputProps {
  control: Control<InviteFormType, any>;
}

export const FirstNameInput = ({ control }: FirstNameInputProps) => (
  <ControllerWrapper name={InviteFlowFields.FIRST_NAME} control={control}>
    {({ onBlur, onChange, error, value }) => (
      <LiliTextInput
        onChange={(v) => onChange(removeWhiteSpacesFromString(v))}
        value={value}
        onBlur={onBlur}
        id={InviteFlowFields.FIRST_NAME}
        title='First Name'
        errorMessage={error?.message}
      />
    )}
  </ControllerWrapper>
);
